module.exports = __webpack_public_path__ + "static/portfolio2-10ebf9598679ca404be1ed59846e8aa9.jpg";